function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
import { SectionLines } from "./SectionLines";
export var Section = function(_param) /*#__PURE__*/ {
    var children = _param.children, _container = _param.container, container = _container === void 0 ? false : _container, _lines = _param.lines, lines = _lines === void 0 ? false : _lines, _backgroundColor = _param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "default" : _backgroundColor, className = _param.className, contentBelowLines = _param.contentBelowLines, style = _param.style, contentClassName = _param.contentClassName, props = _objectWithoutProperties(_param, [
        "children",
        "container",
        "lines",
        "backgroundColor",
        "className",
        "contentBelowLines",
        "style",
        "contentClassName"
    ]);
    return React.createElement("section", _extends({
        "data-section-background-color": backgroundColor,
        style: style,
        className: twMerge(cx(backgroundColor === "default" && cx('[&[data-section-background-color="default"]+[data-section-background-color="default"]]:pt-0', '[&[data-section-background-color="default"]+[data-section-background-color="default"]]:md:pt-0'), backgroundColor === "offdefault" && cx('[&[data-section-background-color="offdefault"]+[data-section-background-color="offdefault"]]:pt-0', '[&[data-section-background-color="offdefault"]+[data-section-background-color="offdefault"]]:md:pt-0'), backgroundColor === "offdefault" && "bg-bg-offdefault", className))
    }, props), /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid grid-cols-1 grid-rows-1", container && "container")
    }, !!lines && /*#__PURE__*/ React.createElement("div", {
        className: twMerge("col-start-1 row-start-1 h-full grid grid-cols-1 grid-rows-1 pointer-events-none", !container && "container", contentBelowLines && "z-20")
    }, /*#__PURE__*/ React.createElement(SectionLines, {
        lines: lines
    })), /*#__PURE__*/ React.createElement("div", {
        className: twMerge("col-start-1 row-start-1 py-7 z-10 md:py-10", contentClassName)
    }, children)));
};

//# sourceMappingURL=Section.js.map